import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

export function useDeleteTask() {
  const { data: user } = useFindProfile()

  const siteId = user && user.selectedSite.id

  async function deleteTask(taskId: number) {
    const url = `sites/${siteId}/tasks/${taskId}`
    const { data } = await api.delete(url)
    return data
  }

  return { deleteTask }
}
